import { Signal } from "signals";
import { HomeCommand } from "slotworks/commands/betbar/home-command";
import { MaxBetMessageCommand } from "slotworks/commands/betbar/max-bet-message-command";
import { HideAllMenusCommand } from "slotworks/commands/menus/hide-all-menus-command";
import { ShowAllMenusCommand } from "slotworks/commands/menus/show-all-menus-command";
import { FindValidTotalStake } from "slotworks/components/betbar/betbar-helpers";
import BetSection from "slotworks/components/betbar/menus/bet-section";
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import Components from "slotworks/components/components";
import SoundToggleComponent from "slotworks/components/sound/sound-toggle-component";
import StepperComponent from "slotworks/components/ui/stepper-component";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import { formatMoney } from "slotworks/utils/string-formatters";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Translations from "slotworks/i18n/translations";
import BetModel from "slotworks/model/bets/bet-model";
import Contract from "slotworks/utils/contract";

export default class IntroPopup {
    private static TEXT: string = "text";
    private static BUTTON_JOIN: string = "btn-join";
    
    private joinButton: FlexiButton;
    private text: FlexiText;

    public onComplete: Function;

    constructor() {
        this.onComplete = ()=>{};
    }

    private setupListeners() {
        this.joinButton = Layers.PromoPopups.getFlexiButton(IntroPopup.BUTTON_JOIN);
        this.joinButton.setEnabled(true);
        this.text = Layers.PromoPopups.getFlexiText(IntroPopup.TEXT);
    }

    private translate() {
        let text = Translations.get(
            'promo_fs_intro',
            {
                spins: CampaignsModel.freespins.remaining,
                bet: formatMoney(BetModel.getTotalBet()),
                useBefore: CampaignsModel.freespins.useBefore
            }
        )
        this.text.setText(text);
    }

    public show(): Contract<void> {
        return new Contract((resolve) => {
            Layers.PromoPopups.setScene("promointro").execute();
            this.setupListeners();
            this.translate();
            Layers.PromoPopups.show();
            this.joinButton.on(ButtonEvent.POINTER_DOWN,() => this.join(resolve));
        })
    }

    private join(resolve: Function) {
        this.hide();
        resolve(null);
    }
    
    public hide() {
        this.joinButton.off(ButtonEvent.POINTER_DOWN,() => this.join(()=>{}));
        this.joinButton.destroy();
        this.text.destroy();
        Layers.PromoPopups.hide();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/promo-popups/intro-popup.ts